import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { useSEO } from "../hooks/useSEO";
import api from "../lib/api";
import { ContactForm } from "../components/contact/ContactForm";
import { ContactInfo } from "../components/contact/ContactInfo";

export default function Contact() {
  const { t, lang } = useLanguage();
  useSEO(
    lang === "nl"
      ? "Contact | EliteTheBarber Kapper Utrecht"
      : "Contact | EliteTheBarber Barber Utrecht",
    lang === "nl"
      ? "Neem contact op met EliteTheBarber, kapper aan de Vlampijpstraat 75g in Utrecht. Bekijk openingstijden en routebeschrijving."
      : "Get in touch with EliteTheBarber, barber on Vlampijpstraat 75g in Utrecht. View opening hours and directions."
  );
  const [settings, setSettings] = useState(null);
  const [hours, setHours] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
    api.get("/working-hours").then(({ data }) => setHours(data)).catch(() => setHours([]));
  }, []);

  const address = settings ? `${settings.address}, ${settings.postal_code} ${settings.city}` : "Vlampijpstraat 75g, 3534 AR Utrecht";
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

  return (
    <div data-testid="contact-page" className="py-20 sm:py-28 px-4 sm:px-6 min-h-[60vh]">
      <div className="max-w-5xl mx-auto">
        <p className="text-gold text-xs uppercase tracking-[0.3em] mb-3">{t("nav.contact")}</p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mb-4 tracking-tight">{t("contact.title")}</h1>
        <p className="text-white/60 text-base mb-12 max-w-lg">{t("contact.subtitle")}</p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <ContactInfo settings={settings} hours={hours} address={address} directionsUrl={directionsUrl} />

          <div className="aspect-[4/3] rounded-xl overflow-hidden border border-white/10">
            <iframe
              data-testid="contact-map-iframe"
              title="EliteTheBarber locatie"
              src={settings?.google_maps_embed_url || "https://www.google.com/maps?q=Vlampijpstraat+75g,+3534+AR+Utrecht&output=embed"}
              width="100%"
              height="100%"
              style={{ border: 0, filter: "grayscale(0.3) invert(0.92) contrast(0.9)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="mt-14 max-w-xl">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}
